(function($){
    $(function($) {

        const ratingTrigger = $(".show-rating-thumb");
        ratingTrigger.on('click', function(e) {
            e.stopPropagation();
            $(this).parent().addClass('open')
        });

    });
})(jQuery);

/** rating */
rate = function(projectId, level, item) {
    const token = $('meta[name="csrf-token"]').attr('content');

    $.ajax({
        url: '/backend/ajax/rate/' + projectId,
        method: "GET",
        dataType: 'JSON',
        data: {'_token': token, 'rating': level}
    }).done(function( result ) {
        console.log('average rating: ', result.average);
        if (result.status === 1) {
            $(item).addClass('active');
        }
        const messageBox = $(item).parents('.rating-message');
        messageBox.html(result.message);
        updateRating(projectId, result.average);
    }).fail(function( jqXHR, textStatus ) {
        console.log( "Request failed: " + textStatus );
    });
}
closeRating = function(item) {
    $(item).parents('.rating').removeClass('open')
}
updateRating = function(id, rating) {
    const ratingContainer = $('#preview_item_' + id ).find('.map-rating');
    let html = '';
    for (let i = 0; i < rating; i++) {
        html += '<span class="fa fa-star mr-1"></span>';
    }
    ratingContainer.html(html);
}
